import React, { useState, useEffect } from "react";

import { useHistory } from "react-router-dom";

//Components imports
import OutgoingDocumentsForm from "../../components/RecordBook/OutgoingDocumentsForm";
import PopUp from "../../components/common/PopUp";
import NavigationBar from "../../components/common/NavigationBar";

// Icons imports
import { BsFileEarmarkArrowUp } from "react-icons/bs";
import { BsFileEarmarkArrowDown } from "react-icons/bs";

// Scss imports
import css from "./RecordBook.module.scss";

// redux
import { useSelector, useDispatch } from "react-redux";
import { getFruits } from "../../redux/actions/getFruitsAction";

import {
  getCertainCategoryPaperNumber,
  addPaper,
  getRecipientAndSenders,
} from "../../redux/actions/papersActions";

import { getActiveCategories } from "../../redux/actions/categoriesActions";

import { getActiveProcessors } from "../../redux/actions/processorsActions";

interface RecordBookProps {}

const RecordBook: React.FC<RecordBookProps> = () => {
  const dispatch = useDispatch();

  // Adding paper status
  const addingPaperStatus = useSelector((state: any) => state.papers.addPaper);

  // All categories
  const categories = useSelector(
    (state: any) => state.allCategories.categoriesActive
  );

  // All active processors
  const processors = useSelector(
    (state: any) => state.allProcessors.processorsActive
  );

  // Certain Category Paper Number
  const certainCategoryPaperNumber = useSelector(
    (state: any) => state.papers.certainCategoryPaperNumber
  );

  // All recipient / senders
  const allRecipientAndSenders = useSelector(
    (state: any) => state.papers.recipientAndSenders
  );

  // Setting up state for the category and processors arrays
  const [categoryListArray, setCategoryListArray] = useState([
    { value: "", name: "Изабери", categoryNumber: "" },
  ]);

  const [usersProcessors, setUsersProcessors] = useState([
    {
      name: "Изабери",
      nationalId: "",
      id: "",
      value: "",
    },
  ]);
  // Setting up categories array
  const categoriesArray = categories.data;

  // From categories array get array for showing categories
  const catArr =
    categoriesArray && categoriesArray.length > 0
      ? categoriesArray.map((element) => {
          return {
            value: element._id,
            name: element.name,
            categoryNumber: element.baseNumber,
          };
        })
      : [];

  // Setting up acyibr processors data array
  const processorsData = processors.data;

  const procArr =
    categoriesArray && categoriesArray.length > 0
      ? processorsData.map((processor) => {
          return {
            name: processor.firstName + " " + processor.lastName,
            nationalId: processor.nationalId,
            id: processor._id,
            value: processor._id,
          };
        })
      : [];

  // State for selected category, depeends on this category give basic number
  const [category, setCategory] = useState(categoryListArray[0].value);

  // State for storing value of base number
  const [baseNumber, setBaseNumber] = useState(
    categoryListArray[0].categoryNumber
  );

  // Logic for getting autosugestions on as input change
  const INPUT_TIMEOUT = 250;

  // Setting up state for value and suggestions
  const [recipientValue, setRecipientValue] = useState("");
  const [nationalIdValue, setNationalIdValue] = useState("");
  const [documentNumberValue, setDocumentNumberValue] = useState("");
  const [subnumber, setSubnumber] = useState("");
  const [shortText, setShortText] = useState("");
  //const [processor, setProcessor] = useState(processorsData[0]._id);
  const [processor, setProcessor] = useState("");
  const [paperType, setPaperType] = useState("outgoing");
  const [suggestions, setSuggestions] = useState([]);
  const [suggestionsProcessor, setSuggestionsProcessor] = useState([]);
  const [remark, setRemark] = useState("");
  const [senderDateValue, setSenderDateValue] = useState("");

  // Setting state for disabled button
  const [disabledButton, setDisabledButton] = useState(true);

  // All recipients and senders
  const usersRecipients =
    allRecipientAndSenders && allRecipientAndSenders.length > 0
      ? allRecipientAndSenders.map((recipientSender) => {
          return {
            name1: recipientSender.recSendName,
            nationalId: recipientSender.recSendNum,
          };
        })
      : [];

  const [userNames, setUserNames] = useState<string[]>([]);

  // Setting up errors
  const [nationalIdError, setNationalIdError] = useState("");
  const [documentNumberError, setDocumentNumberError] = useState("");
  const [recipientError, setRecipientError] = useState("");
  const [processorError, setProcessorError] = useState("");
  const [shortTextError, setShortTextError] = useState("");
  const [categoryError, setCategoryError] = useState("");
  const [remarkError, setRemarkError] = useState("");
  const [senderDateError, setSenderDateError] = useState("");

  // show / hide popup
  const [popupShown, setPopupShown] = useState(false);

  // Function for setting errors
  const settingUpErrors = () => {
    if (
      shortText.length < 5 ||
      recipientValue.length < 2 ||
      nationalIdValue === "" ||
      processor.length <= 1
    ) {
      //setNationalIdError("Унеси матични број фирме");
      //setDocumentNumberError("Унеси број документа");
      setRecipientError("Унеси име примаоца");
      //setProcessorError("Унеси име обрађивача");
      setShortTextError("Кратак садржај мора имати најмање 5 карактера");
      setProcessorError("Унеси обрађивача");
    }
  };

  useEffect(() => {
    if (recipientValue === "") {
      setSuggestions([]);
    }

    // Removing errors
    if (nationalIdValue.length > 0) {
      setNationalIdError("");
    }

    if (documentNumberValue.length > 0) {
      setDocumentNumberError("");
    }

    /*if (nationalIdValue.length < 8) {
      setNationalIdError("Матични број није валидан");
    }*/

    if (recipientValue.length >= 2) {
      setRecipientError("");
    }

    if (processor.length > 0) {
      setProcessorError("");
    }

    if (shortText.length > 4) {
      setShortTextError("");
    }

    if (processor.length > 1) {
      setProcessorError("");
    }

    if (category.length > 0) {
      setCategoryError("");
    }

    // Setting up back errors on deleting values, changing them
    if (shortText.length < 5) {
      setShortTextError("Кратак садржај мора имати најмање 5 карактера");
    }

    if (recipientValue.length < 2) {
      setRecipientError("Унеси име примаоца");
    }

    /*if (nationalIdValue === "") {
      setNationalIdError("Унеси матични број фирме");
    }*/

    if (processor.length <= 1) {
      setProcessorError("Унеси обрађивача");
    }

    if (category.length <= 1) {
      setCategoryError("Унеси категорију");
    }
  }, [
    recipientValue,
    category,
    shortText,
    nationalIdValue,
    documentNumberValue,
    processor,
    category,
  ]);

  useEffect(() => {
    if (
      shortText.length > 0 &&
      recipientValue.length > 0 &&
      nationalIdValue.length >= 8 &&
      usersProcessors.length > 1
    ) {
      setDisabledButton(false);
    }
  }, [recipientValue, shortText, nationalIdValue]);

  // Const map trough array of users
  const mapUsers = (users) => {
    users.map(({ name1 }) => {
      return setUserNames((oldArray) => [...oldArray, name1]);
    });
  };

  useEffect(() => {
    mapUsers(usersRecipients);
    dispatch(getActiveCategories());
    dispatch(getCertainCategoryPaperNumber(categoryListArray[0].value));
    dispatch(getActiveProcessors());
    dispatch(getRecipientAndSenders());
    if (disabledButton === true) {
      settingUpErrors();
    }

    setCategoryListArray([
      { value: "", name: "Изабери", categoryNumber: "" },
      ...catArr,
    ]);

    setUsersProcessors([
      {
        name: "Изабери",
        value: "",
      },
      ...procArr,
    ]);

    // Setting up category papper numberto be equeal to first category value
    getCertainCategoryPaperNumber(
      categories.data ? categories.data[0]._id : ""
    );
  }, []);

  useEffect(() => {
    mapUsers(usersRecipients);
  }, [allRecipientAndSenders]);

  useEffect(() => {
    if (disabledButton === true) {
      settingUpErrors();
    }
  }, [disabledButton]);

  // Function for returning suggestions
  const getSuggestions: any = (value) => {
    return userNames.filter(
      (item) => item.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  };

  // Handle recipient value change, function for returning list of suggestions as input changes
  const onRecipientInputValueChange = (e) => {
    let timeout;
    // clear timeout when input changes value
    clearTimeout(timeout);
    setRecipientValue(e.target.value);

    if (recipientValue.length > 1) {
      setNationalIdValue("");
    }

    /* if (recipientValue.length > 0) {
      // make delayed api call
      timeout = setTimeout(() => {
        setSuggestions(getSuggestions(recipientValue));
      }, INPUT_TIMEOUT);
    } else {
      setSuggestions([]);
    }*/
    if (recipientValue.length > 0) {
      setSuggestions(getSuggestions(recipientValue));
    }
  };

  // Const handle processors value change, function for returning list of suggestions as input changes
  const onProcessorInputValueChange = (e) => {
    setProcessor(e.target.value);

    if (processor.length > 0) {
      setSuggestionsProcessor(getSuggestions(processor));
    }
  };

  // On document number value change
  const onNationalIdInputValueChange = (e) => {
    setNationalIdValue(e.target.value);
  };

  // On national id value change
  const onDocumentNumberInputValueChange = (e) => {
    setDocumentNumberValue(e.target.value);
  };

  // On short text input field value change
  const onShortTextValueChange = (e) => {
    setShortText(e.target.value);
  };

  // On remark text input field value change
  const onRemarkValueChange = (e) => {
    setRemark(e.target.value);
  };

  // On sender date input field value change
  const onSenderDateInputValueChange = (e) => {
    setSenderDateValue(e.target.value);
  };

  // On change category select
  const onSelectChange = (e) => {
    setCategory(e.target.value);

    // Filter array and return object from choosen selected option
    let selectedObject: any = categoryListArray.filter((obj) => {
      return obj.value === e.target.value;
    });

    setBaseNumber(selectedObject[0].categoryNumber);
    //setSubnumber(selectedObject[0].categoryNumber + 1);
    dispatch(getCertainCategoryPaperNumber(selectedObject[0].value));
  };

  useEffect(() => {
    setSubnumber(
      certainCategoryPaperNumber.length === 0
        ? "1"
        : Number(certainCategoryPaperNumber[0].subnumber) + 1 + ""
    );
  }, [certainCategoryPaperNumber]);

  // On processors select change
  const onProcessorSelectChange = (e) => {
    setProcessor(e.target.value);
  };

  // Function for sending outgoing document to the database
  const sendOutgoingDocument = () => {
    dispatch(
      addPaper({
        baseNumber: category,
        shortText: shortText,
        recipientSender: recipientValue,
        RSId: nationalIdValue,
        paperType: paperType,
        processor: processor,
        senderPaperNumber: documentNumberValue,
        senderDate: senderDateValue,
        remark: remark,
      })
    );
  };

  // Function for clearing input fields
  const clearInputFields = () => {
    setRecipientValue("");
    setNationalIdValue("");
    setDocumentNumberValue("");
    setSubnumber("");
    setShortText("");
    setProcessor("");
    setCategory("");

    setSuggestions([]);
    setSuggestionsProcessor([]);
    setRemark("");
    setSenderDateValue("");
    setDisabledButton(true);

    const procc: any = document.getElementById("processors");
    const catt: any = document.getElementById("category");

    // Setting up category and processor select values to first default option
    if (procc) {
      procc.value = "";
    }

    if (catt) {
      catt.value = "";
    }
  };

  // Pop up functions

  // If paper adding is sucessful open popup
  useEffect(() => {
    if (addingPaperStatus === "sucess") {
      setPopupShown(true);

      //openPopup();
    }
  }, [addingPaperStatus]);

  // Function for sending outgoing document to the database
  const sendIncomingDocument = () => {
    dispatch(
      addPaper({
        baseNumber: category,
        shortText: shortText,
        recipientSender: recipientValue,
        RSId: nationalIdValue,
        paperType: paperType,
        processor: processor,
        senderPaperNumber: documentNumberValue,
        senderDate: senderDateValue,
        remark: remark,
      })
    );
  };
  // Tab titles and tab contents array
  const data = [
    {
      id: "1",
      tabTitle: "Одлазна документа",
      tabIcon: <BsFileEarmarkArrowUp />,
      tabContent: (
        <OutgoingDocumentsForm
          categoryListArray={categoryListArray}
          onSelectChange={onSelectChange}
          baseNumber={baseNumber}
          recipientValue={recipientValue}
          onRecipientInputValueChange={onRecipientInputValueChange}
          suggestions={suggestions}
          suggestionsProcessor={suggestionsProcessor}
          setRecipientValue={setRecipientValue}
          nationalIdValue={nationalIdValue}
          documentNumberValue={documentNumberValue}
          subnumber={subnumber}
          usersRecipients={usersRecipients}
          userProcessors={usersProcessors}
          shortText={shortText}
          processor={processor}
          sendOutgoingDocument={sendOutgoingDocument}
          onProcessorInputValueChange={onProcessorInputValueChange}
          setProcessor={setProcessor}
          disabledButton={disabledButton}
          onNationalIdInputValueChange={onNationalIdInputValueChange}
          onDocumentNumberInputValueChange={onDocumentNumberInputValueChange}
          onShortTextValueChange={onShortTextValueChange}
          inputNationalIdError={nationalIdError}
          inputDocumentNumberError={documentNumberError}
          inputRecipientError={recipientError}
          inputProcessorError={processorError}
          inputShortTextError={shortTextError}
          inputCategoryError={categoryError}
          onProcessorSelectChange={onProcessorSelectChange}
          recipientSenderName="Назив примаоца"
          setNationalIdValue={setNationalIdValue}
          remark={remark}
          onRemarkValueChange={onRemarkValueChange}
          inputRemarkError={remarkError}
          senderDateValue={senderDateValue}
          onSenderDateInputValueChange={onSenderDateInputValueChange}
          inputSenderDateError={senderDateError}
          setSuggestions={setSuggestions}
        />
      ),
    },
    {
      id: "2",
      tabTitle: "Долазна документа",
      tabIcon: <BsFileEarmarkArrowDown />,
      tabContent: (
        <OutgoingDocumentsForm
          categoryListArray={categoryListArray}
          onSelectChange={onSelectChange}
          baseNumber={baseNumber}
          recipientValue={recipientValue}
          onRecipientInputValueChange={onRecipientInputValueChange}
          suggestions={suggestions}
          suggestionsProcessor={suggestionsProcessor}
          setRecipientValue={setRecipientValue}
          nationalIdValue={nationalIdValue}
          documentNumberValue={documentNumberValue}
          subnumber={subnumber}
          setNationalIdValue={setNationalIdValue}
          usersRecipients={usersRecipients}
          userProcessors={usersProcessors}
          shortText={shortText}
          processor={processor}
          sendOutgoingDocument={sendIncomingDocument}
          onProcessorInputValueChange={onProcessorInputValueChange}
          setProcessor={setProcessor}
          disabledButton={disabledButton}
          onNationalIdInputValueChange={onNationalIdInputValueChange}
          onDocumentNumberInputValueChange={onDocumentNumberInputValueChange}
          onShortTextValueChange={onShortTextValueChange}
          inputNationalIdError={nationalIdError}
          inputDocumentNumberError={documentNumberError}
          inputRecipientError={recipientError}
          inputProcessorError={processorError}
          inputShortTextError={shortTextError}
          inputCategoryError={categoryError}
          onProcessorSelectChange={onProcessorSelectChange}
          recipientSenderName="Назив пошиљаоца"
          incomingDocument={true}
          remark={remark}
          onRemarkValueChange={onRemarkValueChange}
          inputRemarkError={remarkError}
          senderDateValue={senderDateValue}
          onSenderDateInputValueChange={onSenderDateInputValueChange}
          inputSenderDateError={senderDateError}
          setSuggestions={setSuggestions}
        />
      ),
    },
  ];

  // Setting up state to hold visible tab
  const [visibleTab, setVisibleTab] = useState(data[0].id);

  // On tab title click
  const clickedTabItemHandler = (item) => {
    setVisibleTab(item.id);
  };

  useEffect(() => {
    if (visibleTab === "1") {
      setPaperType("outgoing");
    }

    if (visibleTab === "2") {
      setPaperType("incoming");
    }
  }, [visibleTab]);

  // This function is returning titles
  const titles = data.map((item) => (
    <div>
      {" "}
      <div
        key={item.id}
        onClick={() => clickedTabItemHandler(item)}
        className={`${css.tabItem} ${
          visibleTab === item.id ? css.activeTab : ""
        }`}
      >
        <div className={css.tabIcon}>{item.tabIcon}</div>
        {item.tabTitle}
      </div>
    </div>
  ));

  // This function is returning list content
  const listContent = data.map((item) => (
    <div
      key={item.id}
      className={`${css.tabPane} ${
        visibleTab === item.id ? css.activePane : ""
      }`}
    >
      {item.tabContent}
    </div>
  ));

  return (
    <div>
      <NavigationBar />
      <div className={css.container}>
        <div className={css.tabs}>{titles}</div>
        <div className={css.tabContent}>{listContent}</div>
        {popupShown && (
          <PopUp
            clearInputFields={clearInputFields}
            setPopupShown={setPopupShown}
            setSubnumber={setBaseNumber}
          />
        )}
      </div>
    </div>
  );
};

export default RecordBook;
